<!-- 设备管理-单个 -->
<template>
  <!-- flex:0; -->
  <div class="deviceinfobox" style="display:block;margin:20px;">
    <!-- 设备操作 -->
    <!-- <deviceoperate v-show="!showDevicebelong" @showdetail="showDetail"></deviceoperate> -->
    <!-- 设备信息 -->
    <deviceinfo 
      v-show="!showDevicebelong" 
      @showdetail="showDetail"
      @noticeDeviceBoxOne="backDeviceListTwo"
      @noticeDeviceBtn="noticeDeviceBtnBtn"
    ></deviceinfo>
    <!-- 设备所属数采器 -->
    <devicebelong v-show="showDevicebelong" @showdetail="showDetail"></devicebelong>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
// import deviceoperate from "./deviceoperate";
import deviceinfo from "./deviceinfo";
import devicebelong from "./devicebelong";
export default {
  components: {
    // deviceoperate,
    deviceinfo,
    devicebelong
  },
  data() {
    return {
      // 显示数采器页
      showDevicebelong: false,
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    })
  },
  methods: {
    // 显示所属数采器
    showDetail(val) {
			this.showDevicebelong = val;
		},
    // 点击返回设备列表总表
    backDeviceListTwo(){
      // 通知显示table(隐藏设备信息页)
      this.$emit('noticeDeviceBoxTwo', true);
      // console.log("send:device-single->table");
      // 清空所存store(暂未发现必须)
    },
    noticeDeviceBtnBtn(){
      // 通知当前激活设备列表按钮
      this.$emit('noticeDeviceBtnBtnBtn', 1);
    },
  }
}
</script>

